import ChallengeStatus from "@Enums/ChallengeStatus";
import { ButtonProps, SxProps, useTheme } from "@mui/material";
import BybButton from "./byb-button";

interface IBybButtonChip {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  status?: `${ChallengeStatus}`;
  size?: ButtonProps["size"];
  loading?: boolean;
  onClick?: () => void;
  sx?: SxProps;
}

const BybButtonChip = ({ children, icon, status, size = "small", loading, onClick, sx }: IBybButtonChip) => {
  const theme = useTheme();
  const buttonStyleDisabled = onClick ? false : true;
  return (
    <BybButton
      size={size}
      color="secondary"
      onClick={onClick}
      icon={icon}
      status={status}
      disableRipple={buttonStyleDisabled}
      disableFocusRipple={buttonStyleDisabled}
      disableTouchRipple={buttonStyleDisabled}
      loading={loading}
      sx={{
        padding: theme.spacing(0.75, 1.25),
        width: "fit-content",
        cursor: !buttonStyleDisabled ? "pointer" : "default",
        pointerEvents: !buttonStyleDisabled ? "auto" : "none",
        minWidth: "unset",
        cornerShape: "unset",
        ...sx,
      }}
    >
      {children}
    </BybButton>
  );
};

export default BybButtonChip;
